;(function ($, window, document, undefined) {
    
    // Public Domain/MIT
    // Gist: https://gist.github.com/szydan/a6c85be49b9aa230988d
    var uuid = function uuid() {
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };
    
    $.fn.extend( {
        
        uniqueId: function() {
            if ( !this.id ) {
                this.id = "ui-id-" + uuid();
            }
            return this.id;
        },
        
        removeUniqueId: function() {
            return this.each( function() {
                if ( /^ui-id-.+$/.test( this.id ) ) {
                    $( this ).removeAttr( "id" );
                }
            } );
        }
    } );
    
})(jQuery || window.$, window, document);
